import { render, staticRenderFns } from "./TabPlanets.vue?vue&type=template&id=af904094&scoped=true"
import script from "./TabPlanets.vue?vue&type=script&lang=js"
export * from "./TabPlanets.vue?vue&type=script&lang=js"
import style0 from "./TabPlanets.vue?vue&type=style&index=0&id=af904094&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af904094",
  null
  
)

export default component.exports